import { Injectable } from '@angular/core';
import { Socket } from 'ng-socket-io';
import { BehaviorSubject } from 'rxjs';
import { Storage } from '@ionic/storage';
import { ConfigHelper } from '../../app/helpers/configHelper';
@Injectable()
export class SocketProvider {
   private notificacoes: any[] = [];
   private notificationSubject = new BehaviorSubject<Array<any>>([]);

   // Exponha um Observable para `notification`
   notification$ = this.notificationSubject.asObservable();

   constructor(
      private socket: Socket,
      public storage: Storage
   ) {}

   getNotifications() {
      return this.notificacoes;
   }

   setNotifications() {
      this.notificacoes = [];
      this.notificationSubject.next([]);
   }

   startSocket(route: string) {
      this.socket.on(route, async (payload) => {
         // this.alertSrv.toastNotification(payload);
         if(payload){
         let dataNotificacao;
         if(Array.isArray(payload)){
            this.notificacoes=payload;
            if(payload[0] && payload[0].data){
               dataNotificacao=payload[0].data;
            }
         }else{
            this.notificacoes.push(payload);
            if(payload.data){
               dataNotificacao=payload.data;
            }
         }
         let dataNotificacaoArray: Array<any> = [];
         try {
             const data = await this.storage.get(ConfigHelper.storageKeys.dataNotificacao);
             dataNotificacaoArray = Array.isArray(data) ? data : [];
             
         } catch (error) {
             console.error('Erro ao carregar as notificações:', error);
         }
         const codConcessionaria = await this.storage.get(ConfigHelper.storageKeys.codConcessionaria);
         
         const existingObject = dataNotificacaoArray.find((concessionaria) => concessionaria.codConcessionaria === codConcessionaria);

         if (existingObject) {
             existingObject.data = dataNotificacao;
         } else {
             const objetoData = {
                 codConcessionaria: codConcessionaria,
                 data: dataNotificacao
             };
             dataNotificacaoArray.push(objetoData);
         }
         this.storage.set(ConfigHelper.storageKeys.dataNotificacao, dataNotificacaoArray);
         this.notificationSubject.next(this.notificacoes);

         const audio = new Audio('assets/sound/sound.wav');
         audio.play().catch((error) => {
            console.error('Erro ao tentar tocar o áudio:', error);
         });
      }
      });
   }

   desativarSocket(){
      if (this.socket) {
         this.socket.disconnect();
      }
   }
   
   disconnect() {
      this.socket.removeAllListeners();

   }
}



// WEBPACK FOOTER //
// ./src/providers/socket/socket.ts